if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.menuItemsList = this.querySelector('.header__inline-menu ul');
      this.headerBounds = {};
      this.announcementBar = document.querySelector('.shopify-section-group-header-group.announcement-bar-section');
      this.setHeaderHeight();

      if (this.hasAttribute('side-menu')) {
        closingAccordions('details.menu-accordion')
      }

      if (this.hasAttribute('transparent')) {
        this.isCurrentlyTransparent = true;
        this.isMouseHover = false;
        this.transparentDisclousres = this.transparentDisclousres || this.querySelectorAll('details, localization-form .disclosure__button, header-menu');
        this.setTransparentMouseEvents();
      }

      window.addEventListener('resize', this.setHeaderHeight.bind(this))

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      // this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.clientHeight + 1}px`);
      this.setHeaderPosition();
      if (this.hasAttribute('side-menu')) {
        document.documentElement.style.setProperty('--menu-items-width', `${this.menuItemsList.clientWidth + this.menuItemsList.offsetLeft}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
      });

      observer.observe(this);
      if (this.hasAttribute('transparent')) {
        let transparentObserver = new MutationObserver((entries, observer) => {
          if (this.currentScrollTop <= this.headerBounds.bottom) {
            for (let entry of entries) {
              if (entry.target.classList.contains('disclosure__button') && entry.type == 'attributes' && entry.attributeName == 'aria-expanded') {
                if (entry.target.getAttribute['aria-expanded'] = 'false' && this.isMouseHover == false) {
                  this.setHeaderTransparent()
                }

              }
              if (entry.type == 'attributes' && entry.attributeName == 'open') {
                if (!entry.target.hasAttribute('open')) {
                  if (this.isMobile()) {
                    this.setHeaderTransparent();
                  } else if (!this.isMobile() && this.isMouseHover == false) {
                    this.setHeaderTransparent();
                  }
                }
              }
              if (entry.type == 'attributes' && entry.attributeName == 'hovered') {
                if (!entry.target.hasAttribute('hovered')) {
                  if (this.isMobile()) {
                    this.setHeaderTransparent();
                  } else if (!this.isMobile() && this.isMouseHover == false) {
                    this.setHeaderTransparent();
                  }
                }
              }
            }
          }
        });

        this.transparentDisclousres.forEach(disc => {
          transparentObserver.observe(disc, { attributes: true, childList: true, subtree: true })
        });
      }
    }

    isMobile() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(userAgent)) {
        return true
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true
      }

      return false
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      if (this.announcementBar) {
        const announcementOffset = this.announcementBar.clientHeight - scrollTop >= 0 ? this.announcementBar.clientHeight - scrollTop : 0;
        document.documentElement.style.setProperty('--announcement-height-offset', `${announcementOffset}px`)
      }



      if (this.hasAttribute('transparent')) {
        this.transparent();
      }

      this.currentScrollTop = scrollTop;
      this.setHeaderPosition();

    }

    setHeaderPosition() {
      const headerBottom = this.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom-pos', `${(headerBottom > 0) ? Math.round(headerBottom) : 0}px`);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
    getOpenDisclosure() {
      let isOpen = false;
      this.transparentDisclousres.forEach(disc => {
        if (disc.hasAttribute('open')) {
          isOpen = true;
          return;
        }
        if (disc.hasAttribute('hovered')) {
          isOpen = true;
          return;
        }
        if (disc.getAttribute('aria-expanded') == "true") {
          isOpen = true;
          return;
        }
      })

      return isOpen;
    }
    setHeaderTransparent(mouseEvent) {
      if (!this.isCurrentlyTransparent) {
        if (mouseEvent) this.isMouseHover = false;
        if (!this.getOpenDisclosure()) {
          this.classList.add(this.dataset.transparentSchema, 'transparent');
          this.classList.remove(this.dataset.defaultSchema);
          this.isCurrentlyTransparent = true;
        }
      }

    }
    setHeaderOpaque(mouseEvent) {
      if (this.isCurrentlyTransparent) {
        if (mouseEvent) this.isMouseHover = true;
        this.classList.remove(this.dataset.transparentSchema, 'transparent');
        this.classList.add(this.dataset.defaultSchema);
        this.isCurrentlyTransparent = false;
      }

    }
    transparent() {

      if (!this.dataset.transparentSchema && !this.dataset.defaultSchema) return;
      if (this.currentScrollTop > this.headerBounds.bottom) {
        this.setHeaderOpaque(false);
      } else {
        this.setHeaderTransparent(false);
      }
    }
    setTransparentMouseEvents() {
      const makeOpaque = () => {
        if (this.currentScrollTop <= this.headerBounds.bottom) {
          this.setHeaderOpaque(true)
        }
      }
      const makeTransparent = () => {
        if (this.currentScrollTop <= this.headerBounds.bottom) {
          this.setHeaderTransparent(true)
        }
      }

      this.addEventListener('mouseenter', makeOpaque);
      this.addEventListener('mousemove', makeOpaque);
      this.addEventListener('mouseleave', makeTransparent);
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

if (!customElements.get('static-header')) {
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.setHeaderHeight();
      this.onScrollHandler = this.onScroll.bind(this)
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.hasAttribute('side-menu')) {
        closingAccordions('details.menu-accordion')
      }

      if (this.hasAttribute('transparent')) {
        this.isMouseHover = false;
        this.isCurrentlyTransparent = true;
        this.transparentDisclousres = this.transparentDisclousres || this.querySelectorAll('details, .disclosure__button, header-menu');
        this.createObserver();
        this.currentScrollTop = 0;
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;


        this.setTransparentMouseEvents();
      }
    }

    createObserver() {
      if (this.hasAttribute('transparent')) {
        let observer = new MutationObserver((entries, observer) => {
          for (let entry of entries) {
            if (entry.target.classList.contains('disclosure__button') && entry.type == 'attributes' && entry.attributeName == 'aria-expanded') {
              if (entry.target.getAttribute['aria-expanded'] = 'false' && this.isMouseHover == false) {
                this.setHeaderTransparent()
              }

            }
            if (entry.type == 'attributes' && entry.attributeName == 'open') {
              if (!entry.target.hasAttribute('open')) {
                if (this.isMobile()) {
                  this.setHeaderTransparent();
                } else if (!this.isMobile() && this.isMouseHover == false) {
                  this.setHeaderTransparent();
                }
              }
            }
            if (entry.type == 'attributes' && entry.attributeName == 'hovered') {
              if (!entry.target.hasAttribute('hovered')) {
                if (this.isMobile()) {
                  this.setHeaderTransparent();
                } else if (!this.isMobile() && this.isMouseHover == false) {
                  this.setHeaderTransparent();
                }
              }
            }
          }
        });

        this.transparentDisclousres.forEach(disc => {
          observer.observe(disc, { attributes: true, childList: true, subtree: true })
        });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.clientHeight}px`);
      if (this.hasAttribute('side-menu')) {
        document.documentElement.style.setProperty('--menu-items-width', `${this.menuItemsList.clientWidth + this.menuItemsList.offsetLeft}px`);
      }
      this.setHeaderPosition();

    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.currentScrollTop = scrollTop;
      this.setHeaderPosition();
    }

    setHeaderPosition() {
      const headerBottom = this.header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom-pos', `${(headerBottom > 0) ? Math.round(headerBottom) : 0}px`);
    }

    isMobile() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (/android/i.test(userAgent)) {
        return true
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true
      }

      return false
    }

    getOpenDisclosure() {
      let isOpen = false;
      this.transparentDisclousres.forEach(disc => {
        if (disc.hasAttribute('open')) {
          isOpen = true;
          return;
        }
        if (disc.hasAttribute('hovered')) {
          isOpen = true;
          return;
        }
        if (disc.getAttribute('aria-expanded') == "true") {
          isOpen = true;
          return;
        }
      })

      return isOpen;
    }

    setHeaderTransparent() {
      if (!this.isCurrentlyTransparent) {
        this.isMouseHover = false;
        if (!this.getOpenDisclosure()) {
          this.classList.add(this.dataset.transparentSchema, 'transparent');
          this.classList.remove(this.dataset.defaultSchema);
          this.isCurrentlyTransparent = true;
        }
      }

    }
    setHeaderOpaque() {
      if (this.isCurrentlyTransparent) {
        this.isMouseHover = true;
        this.classList.remove(this.dataset.transparentSchema, 'transparent');
        this.classList.add(this.dataset.defaultSchema);
        this.isCurrentlyTransparent = false;
      }
    }

    setTransparentMouseEvents() {
      this.addEventListener('mouseenter', this.setHeaderOpaque.bind(this));
      this.addEventListener('mousemove', this.setHeaderOpaque.bind(this));
      this.addEventListener('mouseleave', this.setHeaderTransparent.bind(this));
    }
  }

  customElements.define('static-header', StaticHeader)
}